var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alter-form',{attrs:{"labelWidth":"140px","watchImageVisible":false,"modifyData":_vm.modifyData,"formData":_vm.formData},on:{"formSubmit":_vm.formSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }